/* @flow */
import {
  cropableImageModalActionMaker,
  cardBgImageActionMaker,
  eventSettingsActionMaker
} from '@website/components/ActionMakers'
import {
  changeTitleAlignment,
  changeParagraphAlignment,
  changeCardBgOverlayTransparency
} from '@website/components/CommonActions'

export default dispatcher => {
  const changeSubtitleAlignment = (alignment: string) => {
    dispatcher({
      type: 'CHANGE_SUBTITLE_ALIGNMENT',
      value: alignment
    })
  }

  const changeDateAlignment = (alignment: string) => {
    dispatcher({
      type: 'CHANGE_DATE_ALIGNMENT',
      value: alignment
    })
  }

  const changeLocationAlignment = (alignment: string) => {
    dispatcher({
      type: 'CHANGE_LOCATION_ALIGNMENT',
      value: alignment
    })
  }

  const _changeTitleAlignment = alignment => {
    dispatcher(changeTitleAlignment(alignment))
  }

  const _changeParagraphAlignment = alignment => {
    dispatcher(changeParagraphAlignment(alignment))
  }

  const addImage = () => {
    dispatcher({
      type: 'ADD_IMAGE'
    })
  }

  const centerImgActions = (imageUrl: string) => [
    ...cropableImageModalActionMaker(dispatcher)({
      keyForSizes: 'RSVP2CenterImage',
      showRemove: true,
      imageUrl
    })
  ]

  const addCardImage = () =>
    dispatcher({
      type: 'ADD_CARD_IMAGE'
    })

  const removeCardImage = () =>
    dispatcher({
      type: 'REMOVE_CARD_IMAGE'
    })

  const changeCardImgAction = (value: Object, undoable: boolean) => ({
    type: 'CHANGE_CARD_IMAGE',
    value,
    undoable
  })

  const cardImageActions = (
    imageUrl: string,
    bgOverlayTransparency: number
  ) => [
    ...cardBgImageActionMaker(dispatcher)({
      keyForSizes: 'RSVP2card',
      actions: {
        changeImage: ({ url, dimensions, undoable }) =>
          dispatcher(changeCardImgAction({ url, dimensions }, undoable)),
        removeImage: removeCardImage,
        changeTransparency: value => {
          dispatcher(changeCardBgOverlayTransparency(value))
        }
      },
      imageUrl,
      bgOverlayTransparency
    })
    ]
  
  const changeTitleGradientStatus = (newTitleTextGradient: string) => {
    dispatcher({
      type: 'CHANGE_TITLE_TEXT_GRADIENT',
      value: newTitleTextGradient
    })
  }

  return {
    addImage,
    changeTitleGradientStatus,
    changeSubtitleAlignment,
    changeDateAlignment,
    changeLocationAlignment,
    changeTitleAlignment: _changeTitleAlignment,
    changeParagraphAlignment: _changeParagraphAlignment,
    centerImgActions,
    cardImageActions,
    addCardImage,
    eventSettingsActionMaker
  }
}
